import React from 'react';
import PropTypes from 'prop-types';

/**
 * Visual-only placeholder for a future CMS fragment slot.
 *
 * Renders a Kinetic icon as a non-interactive hint that content will appear
 * in this position once the fragment is embedded. The icon is aria-hidden so
 * screen readers skip it entirely.
 *
 * @param {FragmentPlaceholderProps} props
 * @param {string} props.icon - Kinetic icon class string (e.g. 'ddc-icon ddc-icon-search').
 * @param {string} [props.className] - Additional CSS classes for the wrapper element.
 * @param {string} [props['data-testid']] - Test id forwarded to the wrapper element.
 * @returns {React.ReactElement}
 */
const FragmentPlaceholder = ({ icon, className, 'data-testid': testId }) => (
	<div className={className} data-testid={testId}>
		<i
			className={icon}
			aria-hidden="true"
			data-testid={testId ? `${testId}-icon` : undefined}
		/>
	</div>
);

FragmentPlaceholder.propTypes = {
	icon: PropTypes.string.isRequired,
	className: PropTypes.string,
	'data-testid': PropTypes.string
};

FragmentPlaceholder.defaultProps = {
	className: undefined,
	'data-testid': undefined
};

export default FragmentPlaceholder;
